































































import { Component, Vue } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import RecebimentoStore from '@/components/Recebimento/Store/RecebimentoStore'
import ModalGestores from '@/components/RemuneracaoMedica/suporte/components/ModalGestores.vue'
import EventBus from '@/plugins/EventBus'
import { maskDate } from '@/utils/common'

@Component({
  components: {
    ModalGestores,
  },
})
export default class ViewFinanceiroCadastroResponsavelEmpresaMedica extends Vue {
  hospitalSearch: string = ''

  get getRecebimentoStore() {
    return getModule(RecebimentoStore, this.$store)
  }

  get getDadosContratoEGestores() {
    return this.getRecebimentoStore.dadosContratoEGestores
  }

  get getContratoTableHeader() {
    return [
      { text: 'Nome', class: 'table-headers', align: 'left', value: 'nome', sortable: false },
      { text: 'Fonte pagadora', class: 'table-headers', align: 'left', value: 'fontePagadoraNome', sortable: false },
      { text: 'Prestador', class: 'table-headers', align: 'left', value: 'prestadorNome', sortable: false },
      { text: 'Início vigência', class: 'table-headers', align: 'left', value: 'vigenciaInicio', sortable: false },
      { text: 'Criado em', class: 'table-headers', align: 'left', value: 'createdOn', sortable: false },
      { text: 'Status', class: 'table-headers', align: 'left', value: 'status', sortable: false },
      { text: 'Ações', class: 'table-headers', value: '', align: 'center', sortable: false },
    ]
  }

  get showModal() {
    return this.getRecebimentoStore.modalCadastroEmpresaMedicaResponsavel
  }

  set showModal(value: boolean) {
    this.getRecebimentoStore.setModalCadastroEmpresaMedicaResponsavel(value)
  }

  maskDate(date: string) {
    return maskDate(date)
  }

  showModalGestores(item: any) {
    this.getRecebimentoStore.setContratoGestores(item.gestores)
    this.getRecebimentoStore.setFontePagadoraIdContrato(item.fontePagadoraId)
    this.getRecebimentoStore.setContratoId(item.contratoId)
    this.getRecebimentoStore.setModalGestores(true)
  }
}
